import type EnType from '../en-US/common';

export default {
  colon: ':',
  export: 'Exportar',
  delete: 'Excluir',
  view: 'Visualizar',
  send: 'Enviar',
  sending: 'Enviando',
  find: 'Pesquisar',
  save: 'Salvar',
  saveAndExit: 'Salvar e Sair',
  saved: 'Salvo',
  cancel: 'Cancelar',
  close: 'Fechar',
  dismiss: 'Dispensar',
  name: 'Nome',
  value: 'Valor',
  description: 'Descrição',
  updatedIn: 'Última modificação:',
  defaultFolder: 'Pasta Raiz',
  codeGenerate: 'Gerar Código',
  responsible: 'Responsável',
  format: 'Formato',
  moreHelp: 'Ajuda',
  copyToClipboard: 'Copiar para área de transferência',
  noContent: 'Sem Conteúdo',
  enumeratedValue: 'Enumerações',
  'message.requestException': 'Exceção de requisição',
  'message.requestError': 'Exceção de requisição',
  'message.exportSuccess': 'Exportação bem-sucedida.',
  'message.networkFailure': 'Erro de rede, verifique sua conexão ou tente novamente mais tarde',
  'message.serverFailure': 'Erro do servidor, tente novamente mais tarde',
  'button.text.reload': 'Recarregar',
  'message.loadError.checkNetwork': 'Erro de carregamento, verifique se a rede está inoperante',
  'message.scriptError.checkNetworkOrContactStaff':
    "Ocorreu um erro anormal, tente 'Recarregar' ou 'Obter Suporte' para ajudar a resolvê-lo!",
  more: 'Mais',
  download: 'Baixar',
  downloadFileAndUnitSize: 'Baixar({unitSize})',
  viewAsText: 'Ver como texto',
  copyContent: 'Copiar Conteúdo',
  wrap: 'Quebrar linha',
  request: 'Request',
  response: 'Response',
  'request.example.title.right': 'Request',
  'request.example.title.center': ' Request Example',
  'response.example.title.right': 'Response',
  'response.example.title.center': ' Response Example',
  redirect: 'Redirecionar',
  console: 'Console',
  header: 'Cabeçalhos',
  cookie: 'Cookies',
  selectCharset: 'Selecionar Conjunto de Caracteres',
  isCopied: 'Copiado',
  failToCopied: 'Falha ao copiar, por favor registre manualmente o seguinte conteúdo',
  search: 'Pesquisar',
  tryItOut: 'Testar',
  runInApp: 'Run in {appName}',
  graphqlGetTips:
    "Ao fazer uma requisição HTTP GET, a consulta GraphQL deve ser definida no campo 'query' dos Parâmetros.",
  onlineShareHasBeenCopyToTeam:
    'Documentação da API clonada <strong>【{onlineShareName}】</strong> para a equipe <strong>【{teamName}】</strong>',
  'runner.tryItOut': 'Testar',
  'runner.selectCase': 'Selecionar Caso',
  clone: 'Clonar',
  'customDomain.cname.alibaba': 'O domínio é ICP Alibaba Cloud',
  'customDomain.cname.otherCloud': 'O domínio é ICP Tencent Cloud',
  'customDomain.cname.HK': 'Servidor de Hong Kong, um pouco mais lento',
  'onlineShare.export': 'Exportar Dados',
  'onlineShare.export.dataType': 'Formato de Dados',
  'exportData.appDocumentation.json': 'apiDocumentation.{appNameLower}.json',
  'exportData.export.openapi.version': 'Versão OpenAPI Spec',
  'exportData.export.openapi.version.31': 'OpenAPI 3.1',
  'exportData.export.openapi.version.30': 'OpenAPI 3.0',
  'exportData.export.openapi.version.20': 'Swagger 2.0',
  'exportData.export.openapi.includeExtension':
    'Incluindo Campos de Extensão OpenAPI {appName} (x-{appNameLower}-***)',
  'exportData.export.openapi.includeExtension.no': 'Não',
  'exportData.export.openapi.includeExtension.yes': 'Sim',
  'exportData.export.openapi.tags': 'Exportar pasta como campo Tags',
  'exportData.export.openapi.tags.yes': 'Sim',
  'exportData.export.openapi.tags.no': 'Não',
  'onlineShare.clone': 'Clonar para Meu {appName}',
  'onlineShare.notExisted': 'Esta documentação não existe ou foi excluída.',
  'onlineShare.noAccess': 'Você não tem permissão para acessar esta documentação',
  'onlineShare.expired.subTitle':
    'Por favor, entre em contato com o proprietário da documentação para obter acesso.',
  'onlineShare.sendCodeSuccess':
    'Se seu e-mail estiver na lista de permitidos, você receberá o código de verificação em breve.',
  'apidoc.unPublish': 'Este documento ainda não foi publicado',
  'apidoc.unPublish.subTitle':
    'Por favor, entre em contato com o editor do documento para publicá-lo antes de acessar o URL atual.',
  'onlineShare.needPassword': 'Esta documentação requer uma senha para acesso.',
  'onlineShare.resource.notExisted.title': '404',
  'onlineShare.resource.notExisted.subTitle': 'Página não encontrada',
  'onlineShare.resource.notExisted.reload': 'Recarregar',
  backToHome: 'Voltar para página inicial',
  home: 'Início',
  'email.auth.tip': 'Esta documentação requer um código de verificação por e-mail para acesso',
  'customDomain.error.tip': 'Configuração CNAME inválida. Por favor, verifique as regras abaixo.',
  'customDomain.error.tip2': 'Configuração CNAME inválida.',
  previous: 'Página anterior',
  next: 'Próxima página',
  'message.noPrivilege': 'Permissões insuficientes',
  'onlineShare.expired': 'Esta documentação expirou.',
  'onlineShare.notShared': 'Esta documentação ainda não foi compartilhada',

  'docsSite.enableVibeCodingViaMCP.suffix': 'API Specification',
  'docsSite.enableVibeCodingViaMCP': 'MCP',
  'docsSite.enableVibeCodingViaMCP.tooltip':
    'Potencialize sua experiência de codificação Vibe permitindo que ferramentas de IA como Cursor e GitHub Copilot acessem o site completo de documentação da API.',
  'docsSite.enableVibeCodingViaMCP.modal.title': 'MCP',
  'docsSite.enableVibeCodingViaMCP.modal.description':
    '## 🚀 Configuration Guide\n\n### **Prerequisites**\n\n- **Node.js** (version 18 or higher, preferably the latest LTS version).\n- An IDE that supports MCP, such as:\n  - **Cursor**\n  - **VS Code + Cline plugin**\n\n### Configure the IDE\n\n- Copy the following JSON configuration code to add to the MCP configuration file in your IDE:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "npx",\n      "args": [\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\nIf you\'re on **Windows** and the configuration file above isn\'t working, try using the configuration file below instead:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "cmd",\n      "args": [\n        "/c",\n        "npx",\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n## 🎯 How {appName} MCP Server Works?\n\nOnce the {appName} MCP Server is set up, it automatically reads and caches all API documentation data on your local machine. The AI can then retrieve and utilize this data seamlessly.\n\nSimply instruct the AI on what you’d like to achieve with the API documentation. Here are some examples:\n\n1. **Generate Code**: "Use MCP to fetch the API documentation and generate Java records for the \'Product\' schema and related schemas".\n2. **Update DTOs**: "Based on the API documentation, add the new fields to the \'Product\' DTO".\n3. **Add Comments**: "Add comments for each field in the \'Product\' class based on the API documentation".\n4. **Create MVC Code**: "Generate all the MVC code related to the endpoint \'/users\' according to the API documentation".',
  'specialFile.menu.copy.label': 'Copiar Página',
  'specialFile.menu.copy.description': 'Copiar esta página como Markdown para LLMs',
  'specialFile.menu.markdown.label': 'Ver como Markdown',
  'specialFile.menu.markdown.description': 'Ver esta página como texto simples',
  'specialFile.menu.gpt.label': 'Abrir em {gptName}',
  'specialFile.menu.gpt.prompt': 'Ler de {link} para que eu possa fazer perguntas sobre isso.',
  'specialFile.menu.gpt.description': 'Faça perguntas sobre esta página',
  'specialFile.menu.llms.label': 'LLMs.txt',
  'specialFile.menu.llms.description':
    'Fornecer informações para ajudar LLMs a utilizar o site completo de documentação da API',
  'specialFile.failToCopied':
    'Falha ao copiar, adicione .md após a URL da página para visualizar o Markdown.',
  'docsSite.login.error': 'Falha ao fazer login',
  'docsSite.login.error.detail':
    'O JWT retornado pela página de login personalizada não passou a verificação de assinatura, entre em contato com o editor do documento para modificar a configuração.',

  'apiTest.debug.dataSource.error':
    'A versão web não suporta operações de banco de dados no momento, por favor, faça o download da versão {appName} desktop.',
  'apiTest.debug.execute.error':
    'A versão web não suporta chamadas a programas externos no momento, por favor, faça o download da versão {appName} desktop.',
  'apiTest.debug.liveRequire.error':
    'A versão web não suporta a introdução dinâmica de bibliotecas externas no momento, por favor, faça o download da versão {appName} desktop.',
  'customDomain.error.tip.canNotAccess':
    'O nome de domínio atual é usado apenas para configuração CNAME e não pode ser acessado diretamente.',
} satisfies typeof EnType;
